import ResourceCategoryLibrary from "../components/ResourceCategoryLibrary/ResourceCategoryLibrary";
import { WellKnownLearningMaterialCategories } from "UIPalette/LearningMaterials/wellKnownLearningMaterials";
import { useTranslation } from "react-i18next";
import { ResourceViewer } from "../components/ResourceViewer/ResourceViewer";

export const ViewPodcast = () => <ResourceViewer pageTitle="pageTitle.resources.podcasts.article" />;

export const Podcasts = () => {
  const { t } = useTranslation();

  return <ResourceCategoryLibrary category={WellKnownLearningMaterialCategories.podcasts} pageTitle={t("pageTitle.resources.podcasts.home")} />;
};
